import {FormattedButton} from "@dvrt/graphql-widgets";

export default FormattedButton;
